import { useState } from 'react';
import { X, RefreshCw } from 'lucide-react';

import { Button } from '../ui/Button';
import { Snackbar } from '../ui/Snackbar';
import { useAppUpdate } from '../app/useAppUpdate';

export const UpdateSnackbar = () => {
  const deployed = useAppUpdate();
  const [dismissedBuildId, setDismissedBuildId] = useState(null);

  if (!deployed || deployed.buildId === dismissedBuildId) return null;

  return (
    <Snackbar>
      <RefreshCw className="h-4 w-4 shrink-0 text-primary" />
      <div className="flex min-w-0 flex-col">
        <span className="text-sm font-medium text-foreground">New version is out</span>
        <span className="truncate text-xs text-gray-dark">
          v{deployed.version} is live. Refresh to pick it up.
        </span>
      </div>
      <div className="ml-auto flex shrink-0 items-center gap-1">
        <Button variant="primary" onClick={() => window.location.reload()}>
          Refresh
        </Button>
        <Button
          iconButton
          variant="ghost"
          aria-label="Dismiss update notice"
          onClick={() => setDismissedBuildId(deployed.buildId)}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </Snackbar>
  );
};
